import { atom } from "recoil";

export type ThemeMode = "light" | "dark" | "system";

export const themeModeAtom = atom<ThemeMode>({
  key: "themeMode",
  default: "light",
  effects: [
    ({ setSelf, onSet }) => {
      const saved = localStorage.getItem("themeMode") as ThemeMode | null;
      if (saved) setSelf(saved);
      onSet((v) => localStorage.setItem("themeMode", v));
    },
  ],
});
